import { Component, forwardRef, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
  ControlValueAccessor,
  UntypedFormBuilder,
  NG_VALUE_ACCESSOR
} from "@angular/forms";
import { Observable, of, Subscription } from "rxjs";
import { debounceTime, distinctUntilChanged, switchMap, tap } from "rxjs/operators";
import { BanService } from "../../services/ban.service";
import { BanAdresse } from "../../models/banAdresse";
import { faLock } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-adresse',
    templateUrl: './adresse.component.html',
    styleUrls: ['./adresse.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AdresseComponent),
            multi: true
        }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class AdresseComponent implements OnInit, OnDestroy, ControlValueAccessor {

  @Input()
  errors: any = [];

  faLock = faLock;

  searching = false;

  unlocked = false;

  address: string;

  private valueChangesSubscription: Subscription;

  form = this.fb.group({
    id: [],
    numero: [],
    nomVoie: [],
    codePostal: [],
    codeInsee: [],
    nomCommune: [],
    nomComplementaire: [],
    longitude: [],
    latitude: [],
    apiAdresse: [],
  });

  constructor(private fb: UntypedFormBuilder, private banService: BanService) {
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    if (typeof  this.valueChangesSubscription !== 'undefined' && this.valueChangesSubscription !== null) {
      this.valueChangesSubscription.unsubscribe();
    }
  }

  registerOnChange(fn: any): void {
    this.valueChangesSubscription = this.form.valueChanges.subscribe(fn);
  }

  public onTouched: () => void = () => {
  };

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(obj: any): void {
    if(obj){
      this.form.patchValue(obj, {emitEvent: false});
      this.address = [
        obj.numero,
        obj.nomVoie,
        obj.nomComplementaire,
        obj.codePostal,
        obj.nomCommune
      ].join(' ');
    }
  }


  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => this.searching = true),
      switchMap(terms => {
          if (!terms || terms.trim().length <= 2) {
            return of([]);
          }
          return this.banService.search(terms)
        }
      ),
      tap(() => this.searching = false)
    )

  select(event) {
    this.form.patchValue(event.item);
  }

  formatter(adresse: BanAdresse) {
    return adresse.label;
  }

  clearErrors() {
    this.errors = [];
  }
}
